
/**
 * Returns a reducer that calls the appropriate reducer based on the action type
 * If the types object has a field named like the action type, it is called, 
 * Otherwise the state is returned unchanged
 * @param {Object} types action type to reducer mapping, like {"ACTION_TYPE":(state,action)=>[reducer]}
 * @param {Object} defaultState reducer default state
 */
export const actions = (types = {}, defaultState = {}) => (state = defaultState, action) => {
  if (types.hasOwnProperty(action.type)) {
    return types[action.type](state, action);
  }
  return state;
}

/**
 * Returns a reducer that sets the state to a value based on the action type
 * If the values object has a field named like the action type, the corresponding value is returned
 * Otherwise it's returned unchanged
 * @param {Object} values action type to value mapping, like {"ACTION_TYPE":true}
 * @param {Object} defaultState reducer default state
 */
export const toggle = (values = {}, defaultState = false) => actions(
  Object.keys(values)
    .reduce((o, key) => ({
      ...o,
      [key]: _ => values[key]
    }), {}),
  defaultState
);

/**
 * redux combineReducers implementation, but doesn't trigger warnings when additionnal fields
 * are passed
 * @param {Object} functions 
 */
export const combineReducers = functions => (state = {}, action) =>
  Object.keys(functions)
    .reduce((o, key) => {
      o[key] = functions[key](state[key], action);
      return o;
    }, {});

/**
 * Returns a toggle reducer that will set the state to true when the corresponding api call is pending,
 * and false otherwise
 * This is done by naming convention like "ACTION", "ACTION_ERROR" and "ACTION_SUCCESS" names
 * @param {String} actionName Value of the base action type
 */
export const apiToggle = actionName => toggle({
  [actionName]: true,
  [actionName + '_ERROR']: false,
  [actionName + '_SUCCESS']: false,
}, false)

/**
 * Remove a key from a key value object under a condition (cond)
 * Example: 
 * remove({a:'b',b:'a'}, (value,id)=>id==='a') should return {b:'a'}
 * @param {Object} state The key value object
 * @param {Function} cond callback with item and id, 
 * that should return true when the condition is met to delete
 * the item
 */
export const remove = (state = {}, cond) => {
  return Object.keys(state)
    .reduce((memo, id) => {
      if (!cond(state[id], id)) {
        memo[id] = state[id];
      }
      return memo;
    }, {});
}




// WEBPACK FOOTER //
// ./src/reducers/common.js